import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import AddCreditCard from "components/Screens/PaymentV2/PaymentNew/AddCreditCard";
import CustomSnackbar from "components/common/Snackbar";

import { getPlatformConfig } from "selectors/platformConfig";
import { getUserAdditionalInfo } from "selectors/user";
import { getClientSecretApi } from "services/customer";

function PaymentStripeCard({ update, change }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);
  const [snackbarMessage, setSnackbarMessage] = useState(null);

  const userInfo = useSelector(getUserAdditionalInfo);
  const platformConfig = useSelector(getPlatformConfig);

  const { payload: platformPayload = {}, ok: isPlatformConfigLoaded = false } = platformConfig || {};

  let stripePromise = null;
  if (isPlatformConfigLoaded) {
    stripePromise = loadStripe(platformPayload.STRIPE_PUBLISHABLE_KEY);
  }

  const { customerId } = userInfo;

  useEffect(() => {
    if (!customerId) return;

    const fetchClientSecret = async () => {
      try {
        const data = await getClientSecretApi(customerId, dispatch);
        const secret = data.client_secret || data.clientSecret;
        setClientSecret(secret);
      } catch (error) {
        setSnackbarMessage("Failed to initialize payment. Please try again.");
      }
    };

    fetchClientSecret();
  }, [customerId, dispatch]);

  if (!clientSecret) {
    return (
      <div className="onboarding-add-credit-card-payment-container">
        <div className="onboarding-add-credit-card-payment-main-div">
          <div className="credit-card-header">
            <p className="heading-h3-semibold color-text-heading-secondary">Loading Stripe payment form...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Elements
        stripe={stripePromise}
        options={{
          clientSecret,
          appearance: {
            theme: "stripe",
            variables: {
              colorPrimary: "#7b7b7b",
              colorBackground: "#ffffff",
              colorText: "#7b7b7b",
              colorDanger: "#df1b41",
              fontFamily: "Inter, system-ui, sans-serif",
              spacingUnit: "4px",
              borderRadius: "8px",
              fontSizeBase: "16px",
            },
          },
        }}
      >
        <AddCreditCard
          customerId={customerId}
          loading={loading}
          setLoading={setLoading}
          navigate={navigate}
          update={update}
          change={change}
        />
      </Elements>
      <CustomSnackbar
        open={!!snackbarMessage}
        message={snackbarMessage}
        onClose={() => setSnackbarMessage(null)}
        type="error"
      />
    </div>
  );
}

export default PaymentStripeCard;
